import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import registerServiceWorker, { unregister } from './registerServiceWorker'

ReactDOM.render(<App />, document.getElementById('root'))
if (process.env.REACT_APP_UNREGISTER === 'true') {
  console.log('unregister sw')
  unregister()
}

if (process.env.REACT_APP_ENABLE_OFFLINE === 'true') {
  registerServiceWorker()
}



// WEBPACK FOOTER //
// ./src/index.js